import Vue from 'vue';
import Vuex from 'vuex';

import { appRouter } from '@/router/router';

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        lang: 'ZH_CN',
        menuList: [],
        token: '',
        qiniuToken: '',
        name: '',
        avatar: '',
        editor: '',
        openList: [],
        activeKey: '',
        issueInfo: {},
        userid: 0,
        DataCreate: '',
        DataDelete: '',
        DataUpdate: '',
        DataSelect: '',
        DataExport: ''
    },
    mutations: {
        setUserid(state, id) {
            state.userid = id
        },
        setLang(state, val) {
            state.lang = val
        },
        setIssueInfo(state, info) {
            state.issueInfo = info
        },
        setToken(state, val) {
            state.token = 'JWT ' + val
            localStorage.setItem("token", 'JWT ' + val);
        },
        setqnToken(state, val) {
            state.qiniuToken = 'JWT ' + val
            localStorage.setItem("qiniutoken", val);
        },
        setName(state, val) {
            state.name = val
            localStorage.setItem("name", val);
        },
        setDataCreate (state, val) {
          state.DataCreate = val
          localStorage.setItem("DataCreate", val);
        },
        setDataDelete (state, val) {
          state.DataDelete = val
          localStorage.setItem("DataDelete", val);
        },
        setDataUpdate (state, val) {
          state.DataUpdate = val
          localStorage.setItem("DataUpdate", val);
        },
        setDataSelect (state, val) {
          state.DataSelect = val
          localStorage.setItem("DataSelect", val);
        },
        setDataExport (state, val) {
          state.DataExport = val
          localStorage.setItem("DataExport", val);
        },
        setAvatar(state, val) {
            state.avatar = val
            localStorage.setItem("avatar", val);
        },
        setEditor(state, val) {
            // console.log(state,'state');
            // console.log(val,'val');
            state.editor = val
            localStorage.setItem("editor", val);
        },
        setOpenList(state, val) {
            state.openList = val
            localStorage.setItem("openlist", val);
        },
        setActiveKey(state, val) {
            state.activeKey = val
            localStorage.setItem("activekey", val);
        },
        setMenuList(state) {
            var menuList = []
            console.log(state)
            appRouter.forEach((item, index) => {
                menuList.push({
                    title: item.title,
                    icon: item.icon,
                    path: item.path,
                    name: item.name,
                    state,
                    child: [],
                })
                var childrenArr = [];
                item.children.filter(child => {
                    childrenArr.push({
                        title: child.title,
                        path: child.path,
                        icon: child.icon,
                        state,
                        name: child.name,
                    })
                })
                menuList[index].child = childrenArr
            })
            state.menuList = menuList
        },
        logout() {
            var username = localStorage.getItem('username') || '';
            var password = localStorage.getItem('password') || '';
            localStorage.clear();
            localStorage.setItem('username', username);
            localStorage.setItem('password', password);
        }
    },
    actions: {

    },
    modules: {

    }
})

export default store;
